/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('isUser', isUser);

    isUser.$inject = ['Principal'];

    function isUser(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var user = attrs.isUser.replace(/\s+/g, '');

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };
            var defineVisibility = function (reset) {
                if (reset) {
                    setVisible();
                }

                Principal.isUser(user)
                    .then(function (result) {
                        if (result) {
                            element.attr('show', 'true');
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
            };

            if (user.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();
